import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/**
 关于泡泡+
 泡泡+课程
 特别关注
 加盟泡泡+
 加入泡泡+
 联系泡泡+
 */

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      component: resolve => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/HomePage"], resolve),
          meta: {
            title: "泡泡+儿童游泳成长中心"
          }
        },
        {
          path: "/intro",
          name: "intro",
          component: resolve => require(["@/view/Intro"], resolve),
          meta: {
            title: "关于泡泡+"
          },
          children: [
            {
              path: "/intro/story",
              name: "story",
              component: resolve => require(["@/view/intro/Story"], resolve),
              meta: {
                title: "品牌故事"
              }
            },
            {
              path: "/intro/brand_advantage",
              name: "brand_advantage",
              component: resolve =>
                require(["@/view/intro/BrandAdvantage"], resolve),
              meta: {
                title: "品牌优势"
              }
            },
          ]
        },
        {
          path: "/service",
          name: "service",
          component: resolve => require(["@/view/Service"], resolve),
          meta: {
            title: "泡泡+课程"
          },
          children: [
            {
              path: "/service/education",
              name: "education",
              component: resolve => require(["@/view/service/Education"], resolve),
              meta: {
                title: "水上教育"
              }
            },
            {
              path: "/service/teachers",
              name: "teachers",
              component: resolve =>
                require(["@/view/service/Teachers"], resolve),
              meta: {
                title: "师资力量"
              }
            },
          ]
        },
        {
          path: "/news",
          name: "news",
          component: resolve => require(["@/view/News"], resolve),
          meta: {
            title: "特别关注"
          }
        },
        {
          path: "/join",
          name: "join",
          component: resolve => require(["@/view/JoinUs"], resolve),
          meta: {
            title: "加盟泡泡+"
          }
        },
        {
          path: "/job",
          name: "job",
          component: resolve => require(["@/view/JobChance"], resolve),
          meta: {
            title: "加入泡泡+"
          }
        },
        {
          path: "/contactus",
          name: "contactus",
          component: resolve => require(["@/view/ContactUs"], resolve),
          meta: {
            title: "联系泡泡+"
          }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js